import { v3 } from "backoffice-api"

type MarkOptions = {
  mark_all?: boolean
  notification_ids?: number[]
}

export const markNotificationsAsRead = async (params: MarkOptions) => {
  return await v3.markNotificationsAsRead(params)
}
